import { useRegisterAndSubscribeToMachineBindingSubscription } from '../../graphql/generated';

export interface DigitalOutputBindingContext {
  output: string;
  state: boolean;
  finalState?: boolean;
  pulse?: boolean;
  pulseInterval?: number;
}

const useDigitalOutputBinding = (
  machineId: string,
  context: DigitalOutputBindingContext,
  options?: { skip?: boolean }
): void => {
  useRegisterAndSubscribeToMachineBindingSubscription({
    skip: options?.skip,
    variables: {
      input: {
        machineId,
        binding: {
          namespace: 'machine',
          type: 'digitalOutputScript',
          context,
        },
      },
    },
  });
};

export { useDigitalOutputBinding };
